import React, { useState } from 'react';
import axiosInstance, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import { Drawer } from '@primitives';
import Uploader from '../Uploader';

type UploadDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};
function UploadDrawer({ isOpen, onClose }: UploadDrawerProps) {
  const [disabled, setDisabled] = useState(true);
  const [uploadReferenceId, setUploadReferenceId] = useState('');

  const handleOnSubmit = () => {
    const url = getApiUrl(ApiKeys.AGENCY_SERVICABILTY_SUBMIT);
    axiosInstance.patch(url, {}, { params: { referenceId: uploadReferenceId } }).then(res => {});
  };
  return (
    <Drawer
      open={isOpen}
      headerText="Upload updated pincodes"
      onClose={onClose}
      //footer={<Button variant="primary" disabled={disabled} onClick={handleOnSubmit} fullWidth={true}>Submit</Button>}
      showHeaderDivider
    >
      <Uploader setSubmitButtonDisabled={setDisabled} />
    </Drawer>
  );
}

export default UploadDrawer;
